<template>
  <div style="display: none">
    <img
      v-for="(item, index) in mainImg"
      :key="index + 'main'"
      :src="item"
      mode="scaleToFill"
      @load="handLoad"
    />
    <img
      v-if="count > 11"
      v-for="(item, index) in images"
      :key="index"
      :src="item"
      mode="scaleToFill"
    />
  </div>
</template>

<script>
export default {
  name: "PreLoad",
  data() {
    return {
      mainImg: [
        require("@/assets/img/mainPage/projectService_4.jpg"),
        require("@/assets/img/mainPage/projectService_3.jpg"),
        require("@/assets/img/mainPage/projectService_2.jpg"),
        require("@/assets/img/mainPage/projectService_1.jpg"),
        require("@/assets/img/mainPage/projectDetail_4.jpg"),
        require("@/assets/img/mainPage/project_4.jpg"),
        require("@/assets/img/mainPage/projectDetail_3.jpg"),
        require("@/assets/img/mainPage/project_3.jpg"),
        require("@/assets/img/mainPage/projectDetail_2.jpg"),
        require("@/assets/img/mainPage/project_2.jpg"),
        require("@/assets/img/mainPage/projectDetail_1.jpg"),
        require("@/assets/img/mainPage/project_1.jpg"),
      ],
      images: [
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-15.jpg"),
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-14.jpg"),
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-13.jpg"),
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-12.jpg"),
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-11.jpg"),
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-10.jpg"),
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-9.jpg"),
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-8.jpg"),
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-7.jpg"),
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-6.jpg"),
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-5.jpg"),
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-4.jpg"),
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-3.jpg"),
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-2.jpg"),
        require("@/assets/img/documentation/格物智安工地安全管理平台操作说明-1.jpg"),
        require("@/assets/img/documentation/GL-6-A智能安全帽使用说明书-5.jpg"),
        require("@/assets/img/documentation/GL-6-A智能安全帽使用说明书-4.jpg"),
        require("@/assets/img/documentation/GL-6-A智能安全帽使用说明书-3.jpg"),
        require("@/assets/img/documentation/GL-6-A智能安全帽使用说明书-2.jpg"),
        require("@/assets/img/documentation/GL-6-A智能安全帽使用说明书-1.jpg"),
        require("@/assets/img/documentation/基站使用说明书.png"),
        require("@/assets/img/aboutUs/company.jpg"),
        require("@/assets/img/aboutUs/companyBackground.jpg"),
        require("@/assets/img/aboutUs/aboutUsTitle.png"),
        require("@/assets/img/aboutUs/aboutUs.jpg"),
        require("@/assets/img/news/patent1.png"),
        require("@/assets/img/news/patent2.png"),
        require("@/assets/img/news/patentTop.jpg"),
        require("@/assets/img/news/newsTop.png"),
        require("@/assets/img/news/newsBackground.png"),
        require("@/assets/img/news/honor_1.jpg"),
        require("@/assets/img/news/honor_2.jpg"),
        require("@/assets/img/news/honor_3.jpg"),
        require("@/assets/img/news/honor_4.jpg"),
        require("@/assets/img/news/honor_5.jpg"),
        require("@/assets/img/news/honor_6.jpg"),
        require("@/assets/img/news/honorTop.png"),
        require("@/assets/img/news/honorBackground.png"),
        require("@/assets/img/news/news_5.jpg"),
        require("@/assets/img/news/news_4.jpg"),
        require("@/assets/img/news/news_3.jpg"),
        require("@/assets/img/news/news_2.jpg"),
        require("@/assets/img/news/news_1.jpg"),
        require("@/assets/img/news/news.jpg"),
        require("@/assets/img/application/application_7.jpg"),
        require("@/assets/img/application/application_6.jpg"),
        require("@/assets/img/application/application_5.jpg"),
        require("@/assets/img/application/application_4.jpg"),
        require("@/assets/img/application/application_3.jpg"),
        require("@/assets/img/application/application_2.jpg"),
        require("@/assets/img/application/application_1.jpg"),
        require("@/assets/img/application/application.jpg"),
        require("@/assets/img/product/product_dianhanHistory.jpg"),
        require("@/assets/img/product/product_dianhan.jpg"),
        require("@/assets/img/product/product_dianhanIntro.jpg"),
        require("@/assets/img/product/product_safety.jpg"),
        require("@/assets/img/product/product_patrol.jpg"),
        require("@/assets/img/product/product_statisticalTime.jpg"),
        require("@/assets/img/product/product_screen.jpg"),
        require("@/assets/img/product/product_meetingRollCall.jpg"),
        require("@/assets/img/product/product_anomaly.jpg"),
        require("@/assets/img/product/product_review.jpg"),
        require("@/assets/img/product/product_rules.jpg"),
        require("@/assets/img/product/product_live.jpg"),
        require("@/assets/img/product/product_map.jpg"),
        require("@/assets/img/product/product_tagHelmet.jpg"),
        require("@/assets/img/product/product_tagWatch.jpg"),
        require("@/assets/img/product/product_tagCard.jpg"),
        require("@/assets/img/product/product_lora.jpg"),
        require("@/assets/img/product/product_anchorOut.png"),
        require("@/assets/img/product/product_anchorIn.png"),
        require("@/assets/img/product/product_helmet.jpg"),
        require("@/assets/img/product/product_architecture.jpg"),
        require("@/assets/img/product/product.jpg"),
        require("@/assets/img/technology/posPicture.jpg"),
        require("@/assets/img/technology/posBackground.jpg"),
        require("@/assets/img/technology/coreTechnology_6.jpg"),
        require("@/assets/img/technology/coreTechnology_5.jpg"),
        require("@/assets/img/technology/coreTechnology_4.jpg"),
        require("@/assets/img/technology/coreTechnology_3.jpg"),
        require("@/assets/img/technology/coreTechnology_2.jpg"),
        require("@/assets/img/technology/coreTechnology_1.jpg"),
        require("@/assets/img/technology/technology_3.jpg"),
        require("@/assets/img/technology/technology_2.jpg"),
        require("@/assets/img/technology/technology_1.jpg"),
        require("@/assets/img/technology/technology.gif"),
        require("@/assets/img/rotationPlot/rotationPlot_4.jpg"),
        require("@/assets/img/rotationPlot/rotationPlot_2.jpg"),
        require("@/assets/img/rotationPlot/rotationPlot_1.jpg"),
        require("@/assets/img/footer/applet.jpg"),
        require("@/assets/img/footer/app.png"),
        require("@/assets/img/footer/account.jpg"),
        require("@/assets/img/footer/footerBackground.jpg"),
        require("@/assets/img/download/ios.png"),
        require("@/assets/img/download/android.png"),
        require("@/assets/img/download/fxh.png"),
        require("@/assets/img/download/gwzaapp.png"),
        require("@/assets/img/logo.jpg"),
      ],
      count: 0,
    };
  },
  created() {
    this.count = 0;
  },
  methods: {
    handLoad() {
      this.count++;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/preload.vue